import { z } from "zod";

import { ConsultationSteps } from "@/types/api/consultation";
import { ToothBrushHairTypes, ToothBrushTypes } from "@/types/api/patient";
import { MouthTypes, Sectors } from "@/types/api/treatment";

export const createConsultationSchema = z.object({
  patientId: z.number(),
  comment: z.string().nullable(),
  consultationStep: z.enum(ConsultationSteps),
  toothbrushTypes: z.array(z.enum(ToothBrushTypes)).nullish(),
  toothbrushHairTypes: z.array(z.enum(ToothBrushHairTypes)).nullish(),
  toothbrushBrand: z.string().nullish(),
  brushesDimensions: z.string().nullish(),
  brushesBrand: z.string().nullish(),
  sectors: z.array(z.enum(Sectors)).nullish(),
  mouthParts: z.array(z.enum(MouthTypes)).nullish(),
  startDate: z.coerce.date(),
  endDate: z.coerce.date(),
});

export type CreateConsultationFormData = z.infer<
  typeof createConsultationSchema
>;

export const createConsultationDefaultValues: CreateConsultationFormData = {
  patientId: 0,
  comment: null,
  consultationStep: "CONSULTATION",
  startDate: new Date(new Date().setMinutes(0)),
  endDate: new Date(new Date(Date.now() + 3600000).setMinutes(0)),
  toothbrushTypes: null,
  toothbrushHairTypes: null,
  toothbrushBrand: null,
  brushesDimensions: null,
  brushesBrand: null,
  sectors: null,
  mouthParts: null,
};

export const updateConsultationSchema = z.object({
  comment: z.string().nullable(),
  consultationStep: z.enum(ConsultationSteps),
  toothbrushTypes: z.array(z.enum(ToothBrushTypes)),
  toothbrushHairTypes: z.array(z.enum(ToothBrushHairTypes)),
  toothbrushBrand: z.string().nullable(),
  brushesDimensions: z.string().nullable(),
  brushesBrand: z.string().nullable(),
  sectors: z.array(z.enum(Sectors)),
  mouthParts: z.array(z.enum(MouthTypes)),
  startDate: z.coerce.date(),
  endDate: z.coerce.date(),
});

export type UpdateConsultationFormData = z.infer<
  typeof updateConsultationSchema
>;
